import { render, staticRenderFns } from "./Validator.vue?vue&type=template&id=bc4bb4c8&scoped=true&"
import script from "./Validator.vue?vue&type=script&lang=js&"
export * from "./Validator.vue?vue&type=script&lang=js&"
import style0 from "./Validator.vue?vue&type=style&index=0&id=bc4bb4c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4bb4c8",
  null
  
)

export default component.exports